var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshPasswordIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5915 13.6998V17.8665Z",
    fill: "#1E4620"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 9.99984C18.3332 14.5998 14.5998 18.3332 9.99984 18.3332C5.39984 18.3332 2.5915 13.6998 2.5915 13.6998M2.5915 13.6998H6.35817M2.5915 13.6998V17.8665M1.6665 9.99984C1.6665 5.39984 5.3665 1.6665 9.99984 1.6665C15.5582 1.6665 18.3332 6.29984 18.3332 6.29984M18.3332 6.29984V2.13317M18.3332 6.29984H14.6332",
    stroke: "#0E0D1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshPasswordIcon);
export default __webpack_public_path__ + "static/media/refresh-password-icon.801f46cbf0eb9d52c03d10e94773346d.svg";
export { ForwardRef as ReactComponent };